export enum OrderStatus {
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  DELIVERING = 'DELIVERING',
  DELIVERED = 'DELIVERED',
  // RETURNED = 'RETURNED',
  // REFUNDED = 'REFUNDED',
  RECEIVED = 'RECEIVED',
}

export enum AmiliHealthOrderStatus {
  CREATED = 'CREATED',
  PROCESSED = 'PROCESSED',
  DELIVERED = 'DELIVERED',
  RECEIVED = 'RECEIVED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum ORDER_TYPE {
  B2C = 'B2C',
  B2B2C = 'B2B2C',
  RESEARCH = 'RESEARCH',
  OTHERS = 'OTHERS',
  DELETED = 'DELETED',
}

export enum ExternalColumn {
  SERIAL = 'Serial',
  EXTERNAL_ID = 'External ID',
  CONCENTRATION = 'Concentration (ng/ul)',
  VOLUME = 'Volume',
  FIRST_NAME = 'First Name',
  LAST_NAME = 'Last Name',
}

export enum ExternalSampleQuantity {
  MIN = 2,
  MAX = 40,
}

export enum ExternalIdLength {
  MIN = 6,
  MAX = 20,
}

export enum ExternalVolumeMin {
  STOOL = 2,
  DNA = 20,
}

export enum ExternalConcentrationMin {
  DNA = 5,
}

export enum OrderHistoryStatus {
  ADDED = 'added',
  CONFIRMED = 'confirmed',
  DELETED = 'deleted',
}

// Known business segment names - only used to pre-select one in the Edit
// Order invoice modal (useOrderUpdate). The dropdown's options themselves
// come from Xero (GET /xero/business-segments).
export enum BusinessSegment {
  AmiliConsumersAH = 'AMILI Consumers - AH',
  B2COrganic = 'B2C - Organic',
  B2COptimise = 'B2C - Optimise',
  B2BOptimise = 'B2B - Optimise',
  ClinicalBusinessAH = 'Clinical Business - AH',
  ConsumerHealth = 'Consumer Health',
}

export enum TemperatureCondition {
  FROZEN = 'FROZEN',
  THAWED = 'THAWED',
}

export enum PhysicalCondition {
  INTACT = 'INTACT',
  LEAK = 'LEAK',
}

export enum PurchaseType {
  ONE_TIME = 'one-time',
  SUBSCRIPTION = 'subscription',
}

// Required when the order contains a product with `requiresDeliveryType`
export enum OrderDeliveryType {
  CLINIC = 'CLINIC',
  PATIENT = 'PATIENT',
}

export const DELIVER_TO_PATIENT_MAX_QUANTITY = 1;
